<template>
  <div class="wrap">
    <ul class="list-icons mb-0" v-if="display">
      <!-- require -->
      <li :class="{ 'text-success': $v.username.required }">
        <i class="wb-close" aria-hidden="true" v-if="!$v.username.required"></i>
        <i class="wb-check" aria-hidden="true" v-else></i>
        จำเป็นต้องระบุ Username
      </li>

      <!-- minLength -->
      <li
        :class="{
          'text-success': $v.username.required && $v.username.minLength,
        }"
      >
        <i
          class="wb-close"
          aria-hidden="true"
          v-if="!$v.username.required || !$v.username.minLength"
        ></i>
        <i class="wb-check" aria-hidden="true" v-else></i>
        ต้องระบุอย่างน้อย
        {{ $v.username.$params.minLength.min }} ตัวอักษร
      </li>

      <!-- maxLength -->
      <li :class="{ 'text-success': $v.username.maxLength }">
        <i
          class="wb-close"
          aria-hidden="true"
          v-if="!$v.username.maxLength"
        ></i>
        <i class="wb-check" aria-hidden="true" v-else></i>
        ต้องระบุไม่เกิน
        {{ $v.username.$params.maxLength.max }} ตัวอักษร
      </li>

      <!-- maxLength -->
      <li :class="{ 'text-success': $v.username.password }">
        <i class="wb-close" aria-hidden="true" v-if="!$v.username.password"></i>
        <i class="wb-check" aria-hidden="true" v-else></i>
        สามารถใส่ อักขระ a-z ตัวเลข 0-9 หรือ . หรือ _ ได้เท่านั้น
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["$v"],
  data() {
    return {
      display: true,
    };
  },
};
</script>

<style lang="scss" scoped>
div.wrap {
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
  background-color: #f3f3f3;
}
</style>
